/**
 * @generated SignedSource<<dd124e14ada3e36555a188e82e000e83>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSplit_paymentAddresses$data = {
  readonly addresses: ReadonlyArray<{
    readonly address: {
      readonly address: string | null;
      readonly ensDomain: string | null;
      readonly publicProfile: {
        readonly avatarImage: {
          readonly path: string | null;
        } | null;
        readonly displayName: string | null;
      } | null;
      readonly split: {
        readonly allocations: ReadonlyArray<{
          readonly address: {
            readonly address: string | null;
            readonly ensDomain: string | null;
            readonly publicProfile: {
              readonly avatarImage: {
                readonly path: string | null;
              } | null;
              readonly displayName: string | null;
            } | null;
          } | null;
          readonly allocation: number | null;
          readonly basisPoints: number | null;
        } | null> | null;
        readonly bookmark?: {
          readonly name: string | null;
        } | null;
        readonly controllerAddress: {
          readonly address: string | null;
          readonly ensDomain: string | null;
        } | null;
        readonly distributorFee: string | null;
      } | null;
    } | null;
    readonly allocation: number | null;
    readonly basisPoints: number | null;
  } | null> | null;
  readonly " $fragmentType": "useSplit_paymentAddresses";
};
export type useSplit_paymentAddresses$key = {
  readonly " $data"?: useSplit_paymentAddresses$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSplit_paymentAddresses">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ensDomain",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "avatarImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allocation",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "basisPoints",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchSplitName"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSplit_paymentAddresses",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentAddress",
      "kind": "LinkedField",
      "name": "addresses",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "NftSplit",
              "kind": "LinkedField",
              "name": "split",
              "plural": false,
              "selections": [
                {
                  "condition": "fetchSplitName",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "userId",
                          "variableName": "userId"
                        }
                      ],
                      "concreteType": "NftSplitBookmark",
                      "kind": "LinkedField",
                      "name": "bookmark",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ]
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "distributorFee",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EthereumAddressType",
                  "kind": "LinkedField",
                  "name": "controllerAddress",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    (v1/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NftSplitAllocation",
                  "kind": "LinkedField",
                  "name": "allocations",
                  "plural": true,
                  "selections": [
                    (v3/*:: as any*/),
                    (v4/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EthereumAddressType",
                      "kind": "LinkedField",
                      "name": "address",
                      "plural": false,
                      "selections": [
                        (v0/*:: as any*/),
                        (v1/*:: as any*/),
                        (v2/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v3/*:: as any*/),
        (v4/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "PaymentAddresses",
  "abstractKey": null
};
})();

(node as any).hash = "c17c5a7bd613443330e81273715c3ad1";

export default node;
